import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {NavigationService_GetHeaderUspsLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/navigation/v1/service.grpc.lazy';
import {useCustomerSession} from '@aboutyou/user';

export const useGetHeaderUsps = () => {
  const session = useCustomerSession();

  return useGrpcRequest(NavigationService_GetHeaderUspsLazy, {
    session: session ?? null,
  });
};
